import Swal from 'sweetalert2'
import { userService } from '../../helpers/fakebackend/user.service'

const user = JSON.parse(window.localStorage.getItem('user'))
const token = window.localStorage.getItem('access_token')

export const state = {
  user: user,
  token: token,
}

export const actions = {
  init({ dispatch }) {
    dispatch('validate')
  },

  // Logs in the user.
  // eslint-disable-next-line no-unused-vars
  login({ commit }, { username, password }) {
    commit('loginRequest', { username })
    return userService.login(username, password).then(
      (res) => {
        commit('loginSuccess', res.data.user)
        commit('SET_TOKEN', res.data.access_token)
        setTimeout(function() {
          window.location.href = '/'
        }, 2000)
      },
      (er) => {
        commit('loginFailure', er)
      }
    )
  },
  // Logout the user
  logout({ commit }) {
    userService.logout()
    commit('logout')
  },
  // Validates the current user's token and refreshes it
  // with new data from the API.
  // eslint-disable-next-line no-unused-vars
  validate({ commit, state }) {
    return userService
      .fetchUser()
      .then((res) => {
        commit('SET_CURRENT_USER', res.data.user)
        commit('SET_TOKEN', res.data.access_token)
      })
      .catch(() => {
        window.location.href = '/login'
      })
  },
  updateUserDetail({ commit }, payload) {
    return userService.updateUserDetail(payload).then((res) => {
      commit('loginSuccess', res.data.user)
      commit('SET_TOKEN', res.data.access_token)
      Swal('موفق!', 'اطلاعات کاربری شما با موفقیت تغییر یافت', 'success')
    })
  },
  updateUserPassword(payload) {
    return userService.updateUserPassword(payload).then(() => {
      Swal('موفق!', 'رمز عبور شما با موفقیت تغییر یافت', 'success')
    })
  },
  forgotPassword(email) {
    return userService.forgotPassword(email).then((res) => {
      Swal('موفق!', res.data.message, 'success')
    })
  },
  resetPassword(payload) {
    return userService.resetPassword(payload).then(() => {
      Swal('موفق!', 'رمز عبور شما با موفقیت تغییر یافت', 'success')
    })
  },
}
export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.user
  },
}
export const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true }
    state.user = user
  },
  loginSuccess(state, user) {
    state.status = { loggedUser: true }
    state.user = user
  },
  loginFailure(state) {
    state.status = {}
    state.user = null
  },
  logout(state) {
    state.status = {}
    state.user = null
  },
  registerRequest(state) {
    state.status = { registering: true }
  },
  registerSuccess(state) {
    state.status = {}
  },
  registerFailure(state) {
    state.status = {}
  },
  SET_CURRENT_USER(state, newValue) {
    state.user = newValue
    saveState('user', newValue)
  },
  SET_TOKEN(state, token) {
    state.token = token
  },
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}
